import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color } from 'ng2-charts';
import { Globals } from '../../../../globals';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsPage } from '../../../analytics/analytics';
import * as moment from 'moment';
import { ConfigurationServices } from '../../../configuration/services';



/**
 * Generated class for the HomeDashboardToLastSalesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-last-sales',
  templateUrl: 'home-dashboard-last-sales.html',
})
export class HomeDashboardLastSalesPage {



  public lineChartData: ChartDataSets[] = [
    { data: [], label: this.translate.instant('general-actual') }
    , { data: [], label: this.translate.instant('general-anterior') }
  ];
  public lineChartLabels: string[] = [];
  public lineChartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
  };
  public lineChartColors: Color[] = [
    {
      borderColor: 'orange',
      backgroundColor: 'transparent',
    },
    {
      borderColor: '#5d8df9',
      backgroundColor: 'transparent',
    },
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';

  public loader_totals = true;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public translate: TranslateService,
    public configurationServices: ConfigurationServices,
  ) {
    if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {
      //this.sales7days();
      this.getTotals();
    } else {
      this.data_graphic = true;
      this.loader_totals = false;

    }

  }

  sales: any = [];
  total_sales: any = 0;
  total_products_sales: any = 0;
  total_persons: any = 0;
  data_graphic: boolean = false;

  async sales7days() {

    await this.http.post(this.globals.analytics_path + 'sales-elements-7-days/' + this.globals.restaurant_uid, {}).subscribe(async data => {
      this.sales = data;
      this.lineChartLabels = this.sales.graphic.label1;
      this.lineChartData[0].data = this.sales.graphic.data1;
      this.lineChartData[1].data = this.sales.graphic.data2;
      this.total_sales = this.sales.total_sales;
      this.total_products_sales = this.sales.total_elements;
      this.total_persons = this.sales.total_persons;
      this.data_graphic = true;
    },
      err => {
      }
    );
  }
  openAnalytics() {
    this.globals.side_menu_active = 'informes';
    this.navCtrl.push(AnalyticsPage);


  }





  async getTotals() {
    let date_first = moment().subtract(7, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    let date_last = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');

    await this.http.post(this.globals.analytics_path + 'biclosecash/get_totals', {
      public_key: this.globals.public_key,
      uid_cash: 'all',
      datetime_init: new Date(date_first),
      datetime_final: new Date(date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_total = data['total'];
      this.configurationServices.biclosecash_total_notax = data['total_notax'];
      this.configurationServices.biclosecash_total_tax = data['total_tax'];
      this.configurationServices.biclosecash_total_tips = data['total_tips'];
      this.configurationServices.biclosecash_total_with_tips = data['total_with_tips'];
      this.configurationServices.biclosecash_total_taxes = data['total_taxes'];
      this.loader_totals = false;
    },
      err => {
        this.loader_totals = false;
      });
  }



}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-last-sales/home-dashboard-last-sales.ts